import { Component, OnInit } from '@angular/core';

import { ventaLocalModule } from '../../modelo/usuario/ventaLocal';
import { ReporteService } from '../../servicios/reporte.service';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { ViewChild } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { categoriaModule } from '../../modelo/usuario/categoria';
import { element } from 'protractor';
import * as Chart from 'chart.js';
import { LoginService } from '../../servicios/login.service';
import { LocalesModule } from '../../modelo/locales/locales.module';

@Component({
  selector: 'app-report-ventasx-local',
  templateUrl: './report-ventasx-local.component.html',
  styleUrls: ['./report-ventasx-local.component.css']
})
export class ReportVentasxLocalComponent implements OnInit {
  alertService: any;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild(MdbTableDirective) mdbTableDos: MdbTableDirective;

  constructor(private api: ReporteService,private apiLogin: LoginService) { }
  anioselec:string;
  local:string;
  id:string;
  categoria:string;
  meseSelec:string[];
  textoVenta:string;
  aniosselec:string[];
  listCategoria:categoriaModule[];
  cat:categoriaModule;
  selectedProduc:[];
  catSelec:string[];
  productos:ventaLocalModule[];
  anios:[];
  habilitar:boolean;
  id_pais:string;
  usuario:string;
  aniotexto:string;
  aniotexto2:string;
  totalventa:number;
  totaldevolucion:number;
  totalventa2:number;
  totaldevolucion2:number;
  porcentajeVenta:number;
  ventaLocal:ventaLocalModule[];
  anio0:number;
  anio1:number;
  texto:string;
  pais:boolean;
  listaLocales:LocalesModule[];
  ListVentaLocal:ventaLocalModule[];
  ListVentaLocalDos:ventaLocalModule[];
meses:[];
mesesMostrar:[];
mesesAnio = [
  { id: 1, name: 'Enero' },
  { id: 2, name: 'Febrero' },
  { id: 3, name: 'Marzo' },
  { id: 4, name: 'Abril' },
  { id: 5, name: 'Mayo' },
  { id: 6, name: 'Junio' },
  { id: 7, name: 'Julio' },
  { id: 8, name: 'Agosto' },
  { id: 9, name: 'Septiembre' },
  { id: 10, name: 'Octubre' },
  { id: 11, name: 'Noviembre' },
  { id: 12, name: 'Diciembre' },
];



lineChartData: ChartDataSets[] = [
 
];

lineChartLabels: Label[] = [];

lineChartOptions = {
  responsive: true,
};

lineChartColors: Color[] = [
  {
    borderColor: 'black',
    backgroundColor: 'rgba(1,1,1,0)',
  },
  {
    borderColor: 'red',
    backgroundColor: 'rgba(1,1,1,0)',
  },
  {
    borderColor: 'blue',
    backgroundColor: 'rgba(1,1,1,0)',
  },
  {
    borderColor: 'orange',
    backgroundColor: 'rgba(1,1,1,0)',
  },
];

lineChartLegend = true;
lineChartPlugins = [];x
lineChartType = 'line';


public  listarLocales(){
  this.apiLogin.locales(localStorage.getItem("id_pais"))
  .subscribe((
    data: LocalesModule[]) => {
    this.listaLocales = data;
    this.usuario=localStorage.getItem("nombre");
    this.local=localStorage.getItem("nombreLocal");
    this.id=localStorage.getItem("local");
    if (localStorage.getItem("rol")=='MaxiPan' || localStorage.getItem("rol")=='Gerencia CF' )
  {     this.habilitar=false;
  }else{
   this.habilitar=true;
   this.listarAnioxLocal();
   this.categoriaxLocal();
   this.meseSelec=[];
  this.ListVentaLocal=[];
  this.catSelec=[];
  this.productos=[];
  this.listarProductos();
  this.aniosselec=[];
  this.selectedProduc=[];
  this.local=localStorage.getItem("nombreLocal");
  Chart.defaults.global.defaultFontSize = 15;

  }
   console.log(this.listaLocales);
   this.listaLocales.forEach(item => {
    if (item.id.toString() ==this.id){
      localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
    }
    
  });
  },
 // err =>  this.alertService.danger('Error no hay  conexion..')
  );
}

  public polarAreaChartType = 'polarArea';

  ngOnInit(): void {
    this.limpiar();
    this.id_pais=localStorage.getItem("id_pais");
    if (this.id_pais==='593'){
      this.pais=true;
    }else{
      this.pais=false;

    }
    this.listarLocales();


  }

  listarProductos(){

    if (this.selectedProduc.length==0){
    this.api.productoLocal(localStorage.getItem("nombreLocal").substring(0,4),this.id_pais).subscribe((
      data: []) => {
      this.productos=data;
     
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );
   }
  }
  
limpiar(){
   this.meseSelec=[];
  
   this.catSelec=[];
   this.productos=[];
  this.aniosselec=[];
   this.selectedProduc=[];
}

   onChangeLocal($event: Event) {
  
    localStorage.setItem('id', this.id);
    this.listaLocales.forEach(item => {
      if (item.id.toString() ==this.id){
        localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
        this.usuario=localStorage.getItem('nombre');
      this.local=localStorage.getItem('nombreLocal');

     this.listarAnioxLocal();
      this.categoriaxLocal();
     // this.meseSelec=[];
     this.ListVentaLocal=[];
    // this.catSelec=[];
    // this.productos=[];
     this.listarProductos();
     //this.aniosselec=[];
    // this.selectedProduc=[];
     this.local=localStorage.getItem("nombreLocal");
     Chart.defaults.global.defaultFontSize = 15;

      }
      
    });
   
    }


onKeypressEvent(value:string){
  let valida=false;
  this.productos = this.productos.filter((item) => {
    if (item.producto.toUpperCase().indexOf(value.toUpperCase()) > -1){
      valida=true;
      return item.producto.toUpperCase().indexOf(value.toUpperCase()) > -1;
    }
  });
  if (valida==false){
    this.listarProductos();
  }
}

   listarDetalleVentaGridDos(anio:string,mes:string,categorias:string,productos:string){
    this.totalventa2=0;
    this.totaldevolucion2=0;
    this.aniotexto2=anio;
    this.api.detVentaxlocal(localStorage.getItem("nombreLocal").substring(0,4),anio,mes,categorias,productos,this.id_pais).subscribe((
      data: []) => {
        this.ListVentaLocalDos=data;

        this.ListVentaLocalDos.forEach(element => {
          let porcentaje=0.0;  
          if  (element.venta>0){
              porcentaje=(element.devolucion/element.venta)*100
            }else{
              porcentaje=0;
            }
             if (porcentaje>=0 && porcentaje<10){
               element.color="white"
             }
             if (porcentaje>=10 && porcentaje<15){
              element.color="yellow"
            }
            if (porcentaje>=15 && porcentaje<30){
              element.color="orange"
            }
            if (porcentaje>=30){
              element.color="red"
            }
        });

        this.ListVentaLocalDos.forEach(element => {
          this.ListVentaLocal.forEach (dato => {  
            if (dato.codigo===element.codigo){
              dato.venta2=element.venta;
              dato.devolucion2=element.devolucion;
        
            }
          });


         
         
          this.ListVentaLocal.forEach(element => {
            let porcentaje=0.0;  
            if  (element.venta2>0){
                porcentaje=(element.devolucion2/element.venta2)*100
              }else{
                porcentaje=0;
              }
              let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
               if (valor>=0 && valor<10){
                 element.color2="white"
               }
               if (valor>=10 && valor<15){
                element.color2="yellow"
              }
              if (valor>=15 && valor<30){
                element.color2="orange"
              }
              if (valor>=30){
                element.color2="red"
              }
          });
         
          
      
        });

        this.totalventa2=0;
    this.totaldevolucion2=0;
    
    this.ListVentaLocalDos.forEach(element => {
          this.totaldevolucion2=this.totaldevolucion2+Number.parseFloat(element.devolucion.toString());
        this.totalventa2=this.totalventa2+Number.parseFloat(element.venta.toString());
     
        });
       
        if (this.totalventa2>0){
        this.porcentajeVenta=  100*(((this.totalventa2/this.totalventa))-1);
        this.porcentajeVenta= Math.round((  this.porcentajeVenta + Number.EPSILON) * 100) / 100
        }

        this.ListVentaLocal.forEach(element => {
        
         
            if ( isNaN(element.devolucion2)){
              element.porcentajeDevolucionTotal=0;
            }else{
              if (element.venta2<=0  && element.devolucion2>0){
                element.porcentajeDevolucionTotal=100
                element.color2="red"
           }else{
          element.porcentajeDevolucionTotal=(element.devolucion2/element.venta2)*100
          element.porcentajeDevolucionTotal= Math.round(( element.porcentajeDevolucionTotal + Number.EPSILON) * 100) / 100
           }
        }
        });
        this.mdbTable.setDataSource(this.ListVentaLocal);
        
      
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );
   }

  listarDetalleVentaGridUno(anio:string,mes:string,categorias:string,productos:string){
    this.totalventa=0;
    this.totaldevolucion=0;
    this.aniotexto=anio;
    this.api.detVentaxlocal(localStorage.getItem("nombreLocal").substring(0,4),anio,mes,categorias,productos,this.id_pais).subscribe((
      data: []) => {
        this.ListVentaLocal=data;

        this.ListVentaLocal.forEach(element => {
          let porcentaje=0.0;  
          if  (element.venta>0){
              porcentaje=(element.devolucion/element.venta)*100
            }else{
              porcentaje=0;
            }
            let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
             if (valor>=0 && valor<10){
               element.color="white"
             }
             if (valor>=10 && valor<15){
              element.color="yellow"
            }
            if (valor>=15 && valor<30){
              element.color="orange"
            }
            if (valor>=30){
              element.color="red"
            }
        });

        this.totalventa=0;
        this.totaldevolucion=0;
       
        this.ListVentaLocal.forEach(element => {
          this.totaldevolucion=this.totaldevolucion+Number.parseFloat(element.devolucion.toString());
          this.totalventa=this.totalventa+Number.parseFloat(element.venta.toString());
        });
       
        if (this.totalventa2>0){
          this.porcentajeVenta=  ((this.totalventa2/this.totalventa)-1)*100;
          this.porcentajeVenta= Math.round((  this.porcentajeVenta + Number.EPSILON) * 100) / 100
 
          }
         

         

         

        this.mdbTable.setDataSource(this.ListVentaLocal);
       // this.mdbTablePagination.setMaxVisibleItemsNumberTo(10)
        this.mdbTable.dataSourceChange();
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );
   }


   listarDetalleVentaGrid(anio:string,mes:string,categorias:string,productos:string){
    this.totalventa=0;
    this.totaldevolucion=0;
    this.aniotexto=anio;
    this.api.detVentaxlocal(localStorage.getItem("nombreLocal").substring(0,4),anio,mes,categorias,productos,this.id_pais).subscribe((
      data: []) => {
        this.ListVentaLocal=data;

        this.ListVentaLocal.forEach(element => {
          let porcentaje=0.0;  
          if  (element.venta>0){
              porcentaje=(element.devolucion/element.venta)*100
            }else{
              porcentaje=0;
            }
            let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
             if (valor>=0 && valor<10){
               element.color="white"
             }
             if (valor>=10 && valor<15){
              element.color="yellow"
            }
            if (valor>=15 && valor<30){
              element.color="orange"
            }
            if (valor>=30){
              element.color="red"
            }
        });

        this.totalventa=0;
        this.totaldevolucion=0;
       
        this.ListVentaLocal.forEach(element => {
          this.totaldevolucion=this.totaldevolucion+Number.parseFloat(element.devolucion.toString());
          this.totalventa=this.totalventa+Number.parseFloat(element.venta.toString());
        });
       
        if (this.totalventa2>0){
          this.porcentajeVenta=  100*((this.totalventa2/this.totalventa)-1);
          this.porcentajeVenta= Math.round((  this.porcentajeVenta + Number.EPSILON) * 100) / 100
 
          }
         

         

         

        this.mdbTable.setDataSource(this.ListVentaLocal);
       // this.mdbTablePagination.setMaxVisibleItemsNumberTo(10)
        this.mdbTable.dataSourceChange();
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );
   }
   onChangeArticulo(event: Event) {
   // this.ventaPorLocal();
    //this.listarProductos();
  }

   sortArray(array) {
    var temp = 0;
    for (var i = 0; i < array.length; i++) {
      for (var j = i; j < array.length; j++) {
        if (array[j] < array[i]) {
          temp = array[j];
          array[j] = array[i];
          array[i] = temp;
        }
      }
    }
    return array;
  }
  
  
  ventaPorLocal(){
    let meses="";
    let aniostring="";
    let categorias="";
    let productos="";
    let datos :any[];
    let datosDev:any[];
    let mesesOrderna: number[];
    let datos1 :any[];
    let datosDev1:any[];
    mesesOrderna=[];
    this.totalventa2=0;
    this.totaldevolucion2=0;
    this.totaldevolucion=0;
    this.totalventa=0;
    this.meseSelec.forEach(element => {
          meses=meses+element+",";
          mesesOrderna.push(Number.parseInt(element));
    });
    let mesOrdenador = mesesOrderna.sort((a, b) => a - b);
    this.aniosselec.forEach(element => {
      aniostring=aniostring+element+",";
});
    this.catSelec.forEach(element=>{
      categorias=categorias+"'"+element+"',";
    });

    this.selectedProduc.forEach(element=>{

      productos=productos+"'"+element+"',";
    });
    if (aniostring.length>0){
      aniostring=aniostring+'0';
      }else{
        aniostring="''"
      }
    if (meses.length>0){
    meses=meses+'0';
    }else{
      meses="''"
    }
    if (categorias.length>0){
    categorias=categorias+"'0'"
    }else{
      categorias="''"
    }

    if (productos.length>0){
      productos=productos+"'0'"
      }else{
        productos="NO"
      }


    datos=[];
    datosDev=[];
    datos1=[];
    datosDev1=[];
    this.lineChartLabels=[];
    if (this.aniosselec.length>1){
      if (this.aniosselec[0]>this.aniosselec[1]){
        this.anio0=Number.parseInt(this.aniosselec[1]);
        this.anio1=Number.parseInt(this.aniosselec[0]);

      }else{
        this.anio0=Number.parseInt(this.aniosselec[0]);
        this.anio1=Number.parseInt(this.aniosselec[1]);
      }
      aniostring=this.anio0+this.anio1+",";
      this.lineChartLabels=[];
      this.ListVentaLocalDos=[];
      this.totalventa2=0;
      this.totaldevolucion2=0;
     
      this.listarDetalleVentaGrid(this.anio0.toString(), meses,categorias,productos);
      this.api.ventaxlocal(localStorage.getItem("nombreLocal"), this.anio0.toString(), meses,categorias,productos,this.id_pais).subscribe((
           data: []) => {
           this.ventaLocal=data;
           this.ventaLocal.forEach(element => {
            datos.push(element.venta)
            datosDev.push(element.devolucion);
           // this.lineChartData.push(element.venta);
       
           });
         
           this.listarDetalleVentaGridDos(this.anio1.toString(), meses,categorias,productos);
           this.api.ventaxlocal(localStorage.getItem("nombreLocal"), this.anio1.toString(), meses,categorias,productos,this.id_pais).subscribe((
                data: []) => {
                this.ventaLocal=data;
                this.lineChartLabels=[];
                mesOrdenador.forEach(mes=>{
                  if (mes===1){
                    this.lineChartLabels.push('ENERO')
                  }
                  if (mes===2){
                    this.lineChartLabels.push('FEBRERO')
                  }
                  if (mes===3){
                    this.lineChartLabels.push('MARZO')
                  }
                  if (mes===4){
                    this.lineChartLabels.push('ABRIL')
                  }
                  if (mes===5){
                    this.lineChartLabels.push('MAYO')
                  }
                  if (mes===6){
                    this.lineChartLabels.push('JUNIO')
                  }
                  if (mes===7){
                    this.lineChartLabels.push('JULIO')
                  }
                  if (mes===8){
                    this.lineChartLabels.push('AGOSTO')
                  }
                  if (mes===9){
                    this.lineChartLabels.push('SEPTIEMBRE')
                  }
                  if (mes===10){
                    this.lineChartLabels.push('OCTUBRE')
                  }
                  if (mes===11){
                    this.lineChartLabels.push('NOVIEMBRE')
                  }
      
                  if (mes===12){
                    this.lineChartLabels.push('DICIEMBRE')
                  }
      



                });

                this.ventaLocal.forEach(element => {
                 datos1.push(element.venta)
                 datosDev1.push(element.devolucion);
                // this.lineChartData.push(element.venta);
                 
                });
                this.lineChartData.push
               
                this.lineChartData = [
                 { data:datos, label: 'Ventas  :'+this.anio0 },
                 { data:datosDev, label: 'Devolucion :'+this.anio0  },
                 { data:datos1, label: 'Ventas :'+this.anio1 },
                 { data:datosDev1, label: 'Devolucion :'+this.anio1 },
               ];
              
     
               console.log(this.ventaLocal);
              }, 
              err =>  this.alertService.danger('Error no hay  conexion..')
              );
          console.log(this.ventaLocal);
         }, 
         err =>  this.alertService.danger('Error no hay  conexion..')
         );
       
    }else{
      this.lineChartLabels=[];
      this.ListVentaLocalDos=[];
      this.totalventa2=0;
      this.totaldevolucion2=0;
      this.aniotexto="";
      this.aniotexto2="";
    this.listarDetalleVentaGridUno(this.aniosselec[0], meses,categorias,productos);
      this.api.ventaxlocal(localStorage.getItem("nombreLocal").substring(0,4), this.aniosselec[0], meses,categorias,productos,this.id_pais).subscribe((
           data: []) => {
           this.ventaLocal=data;
           this.ventaLocal.forEach(element => {
            datos.push(element.venta)
            datosDev.push(element.devolucion);
           // this.lineChartData.push(element.venta);
           });
           this.lineChartLabels=[];
           mesOrdenador.forEach(mes=>{
             if (mes===1){
               this.lineChartLabels.push('ENERO')
             }
             if (mes===2){
               this.lineChartLabels.push('FEBRERO')
             }
             if (mes===3){
               this.lineChartLabels.push('MARZO')
             }
             if (mes===4){
               this.lineChartLabels.push('ABRIL')
             }
             if (mes===5){
               this.lineChartLabels.push('MAYO')
             }
             if (mes===6){
               this.lineChartLabels.push('JUNIO')
             }
             if (mes===7){
               this.lineChartLabels.push('JULIO')
             }
             if (mes===8){
               this.lineChartLabels.push('AGOSTO')
             }
             if (mes===9){
               this.lineChartLabels.push('SEPTIEMBRE')
             }
             if (mes===10){
               this.lineChartLabels.push('OCTUBRE')
             }
             if (mes===11){
               this.lineChartLabels.push('NOVIEMBRE')
             }
 
             if (mes===12){
               this.lineChartLabels.push('DICIEMBRE')
             }
              });
           this.lineChartData.push
           this.lineChartData = [
            { data:datos, label: 'Ventas:'+this.aniosselec[0] },
            { data:datosDev, label: 'Devolucion:'+this.aniosselec[0] },
          ];
          this.textoVenta="";
          this.porcentajeVenta=0;
          
         }, 
         err =>  this.alertService.danger('Error no hay  conexion..')
         );
        }
      }

  fieldsChange(ev):void {

    if(ev.target.checked){
      this.aniosselec.push(ev.target.defaultValue);
      this.aniotexto=ev.target.defaultValue;
       }else{
         const index: number =this.aniosselec.indexOf(ev.target.defaultValue);
         if (index !== -1) {
           this.aniosselec.splice(index, 1);
        
       }  
       }
       this.listarMesesVendidos();
   // this.ventaPorLocal();


    
  }

buscar(){
  this.ventaPorLocal();
}

  fieldsChangeCategoria(ev):void {

    if(ev.target.checked){
    //this.listarMesesVendidos(ev.target.defaultValue)
     this.catSelec.push(ev.target.defaultValue);
    // this.ventaPorLocal();
    }else{
      if(ev.target.checked==false){
        const index: number =this.catSelec.indexOf(ev.target.defaultValue);
        if (index !== -1) {
          this.catSelec.splice(index, 1);
       //  this.ventaPorLocal();
      }  
      }

    }
    
  }
  fieldsChangeMes(ev):void {

    if(ev.target.checked){
   this.meseSelec.push(ev.target.defaultValue);
    }else{
      const index: number =this.meseSelec.indexOf(ev.target.defaultValue);
      if (index !== -1) {
        this.meseSelec.splice(index, 1);
     
    }  
    }
    
  //  this.ventaPorLocal();
    console.log(this.meseSelec);
  }

  listarMesesVendidos(){
    this.mesesMostrar =[];
    this.mesesAnio.forEach(element => {
        this.mesesMostrar.push(element as never);
      });
   
  /*  this.api.meses(localStorage.getItem("nombreLocal"),anio).subscribe((
      data: []) => {
      this.meses=data;
      this.meses.forEach(mes => {
      this.mesesAnio.forEach(element => {
          if (element.id==mes[0]){
            this.mesesMostrar.push(element);
          }
        });
       
      });
    
    },
    err =>  this.alertService.danger('Error no hay  conexion..')
    );
    console.log(this.mesesMostrar);
    */
   }

  

  listarAnioxLocal(){
    if (this.aniosselec.length==0){
  this.api.anios(localStorage.getItem("nombreLocal").substring(0,6),this.id_pais).subscribe((
       data: []) => {
       this.anios=data;
       console.log(this.anios);
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
    }
  }

    categoriaxLocal(){
      if (this.catSelec.length==0){
      this.listCategoria = [];
      let i=0;
      this.api.categoriaLocal(localStorage.getItem("nombreLocal"),this.id_pais).subscribe((
           data: []) => {
             data.forEach(element => {
               console.log(element[0]);
               this.cat= new categoriaModule();
               this.cat.name=element[0];
               this.cat.id=i;
               this.listCategoria.push(this.cat);
               i++;
             });
         
          console.log(this.listCategoria);
         },
         err =>  this.alertService.danger('Error no hay  conexion..')
         );
        }
      }

    

}
